import React           from 'react';
//import colors          from '../../utils/colors';
import { makeStyles }  from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        display:         'flex',
        flex:            1,
        alignItems:      'center',
        justifyContent:  'center',
    },
    unit: {
        height:       40,
        flex:         1,
        borderLeft:   '1px solid #FFF',
        borderBottom: '1px solid #FFF'
    }
}))


type ScoreUnitProps = {
    score:      string[];
    myIndex:    number;
}
const ScoreUnit: React.FC<ScoreUnitProps> = ({ 
    score,
    myIndex,
}) => {

  const classes = useStyles();

  return (
    <div className = { classes.root }>
             {
                 score.map((val, ind) => {

                     return(
                        <div
                            key       = { `score--${ myIndex }${ ind }` }
                            className = { classes.unit }
                            style     = {{
                                backgroundColor: 
                                  val === '0' ? '#F77'
                                  :
                                  val === '1' ? '#4E7'
                                  :
                                  val === '2' ? '#F00'
                                  : 
                                  '#DDD'
                            }}
                        />
                     )
                 })
             }
    </div>
  );
}




export default ScoreUnit;



